export default __webpack_public_path__ + "static/media/formPhoneIcon.93921c48.svg";